import { CustomTable, TableEmptyState } from '../../../../../components'
import { EscalaList } from '../../core/_models'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { minhaEscalaColumns } from './columns/_columns'

export const MinhaEscalaTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()

  return (
    <CustomTable<EscalaList>
      id='kt_table_minha_escala'
      ariaLabel='Minhas escalas cadastradas'
      itemLabel={{ singular: 'escala', plural: 'escalas' }}
      data={response?.data || []}
      columns={minhaEscalaColumns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhuma escala cadastrada'
          description='Use “Nova escala” para informar quando você atende.'
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
